import React from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import COLORS from '../../constants/colors';

interface CodeBlockProps {
  value: React.ReactNode;
  /** Caps tall JSON dumps so one payload cannot push the rest of the tab off-screen. */
  maxHeight?: number;
}

/**
 * Raw JSON and machine values were rendered in bare `<pre>` tags, which meant
 * no wrapping and horizontal overflow across the whole page.
 */
export function CodeBlock({ value, maxHeight = 320 }: CodeBlockProps) {
  return (
    <Box
      component="pre"
      sx={{
        m: 0,
        p: '12px 14px',
        borderRadius: '8px',
        border: `1px solid ${alpha(COLORS.MAIN_DARK, 0.08)}`,
        backgroundColor: alpha(COLORS.MAIN_DARK, 0.03),
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
        fontSize: '0.75rem',
        lineHeight: 1.6,
        color: COLORS.DARK_GREY,
        maxHeight,
        overflow: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {value}
    </Box>
  );
}
